<template>
<section class="features">
  <div class="container">
    <div class="features-body">
      <h4>Мы там, где:</h4>
      <ul>
        <li>требуется высокое качество ремонтных работ</li>
        <li>нужно четко соблюсти бюджет</li>
        <li>необходимо ответственно подойти к процессу</li>
      </ul>
    </div>
  </div>
  <div class="features-bg">
    <div class="features-bg__shadow"></div>
    <picture>
      <source srcset="../../public/static/images/sectionFeatures/1.webp">
      <img src="../../public/static/images/sectionFeatures/1.jpg" alt="">
    </picture>
  </div>
</section>
</template>

<script>
export default {
  name: 'SectionFeatures',
  components: {},
  methods: {},
  computed: {},
  mounted() {
  }
}
</script>

<style scoped lang='scss'>
.features {
  overflow: hidden;
  padding: 190px 0;
  position: relative;
  @media (max-width: 1199.98px) {
    padding: 150px 0;
  }
  @media (max-width: 575.98px) {
    padding: 100px 0;
  }
  .container {
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: center;
    h4 {
      font-weight: 300;
      font-size: 4rem;
      color: #FFFFFF;
      margin-bottom: 5rem;
    }
    li {
      position: relative;
      font-weight: 300;
      font-size: 2.2rem;
      color: #fff;
      padding-left: 22px;
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
      &:before {
        position: absolute;
        content: '';
        top: 5px;
        left: 0;
        width: 10px;
        height: 10px;
        background-color: #fff;
      }
    }
  }
  &-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
    &__shadow {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background-color: #000;
      opacity: .6;
    }
  }
}
</style>
